import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=2e605ee0&scoped=true"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=2e605ee0&prod&lang=scss&scoped=true"
import style1 from "./messageDetail.vue?vue&type=style&index=1&id=2e605ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e605ee0",
  null
  
)

export default component.exports